import { Pipe, PipeTransform } from '@angular/core';
import {
  STATUS_COLOR_KEYED_REGISTRY,
  STATUS_COLOR_REGISTRY,
  StatusDomain,
} from './status-color-registry';

const KEYED_DEFAULTS: Partial<Record<StatusDomain, string>> = {
  shiftBook: 'black',
  maintenanceNotification: 'gray',
};

@Pipe({
  name: 'statusColor',
  standalone: true,
})
export class StatusColorPipe implements PipeTransform {
  transform(
    value: number | string | boolean | null | undefined,
    domain: StatusDomain,
  ): string {
    if (value === null || value === undefined) {
      return KEYED_DEFAULTS[domain] ?? '';
    }

    const keyedMap = STATUS_COLOR_KEYED_REGISTRY[domain];

    if (keyedMap && typeof value === 'string') {
      return keyedMap[value] ?? KEYED_DEFAULTS[domain] ?? '';
    }

    if (keyedMap && typeof value === 'boolean') {
      return keyedMap[value.toString()] ?? KEYED_DEFAULTS[domain] ?? '';
    }

    const colorArray = STATUS_COLOR_REGISTRY[domain];
    if (colorArray && typeof value === 'number') {
      return colorArray[value] ?? '';
    }

    return KEYED_DEFAULTS[domain] ?? '';
  }
}
